import { render, staticRenderFns } from "./contentWidget.vue?vue&type=template&id=7ccba790&"
import script from "./contentWidget.vue?vue&type=script&lang=js&"
export * from "./contentWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
